export const CURRENCY_TYPE = '$';
export const BESTSELLER_SELL_COUNT = 20;
export const USER_TOKEN = 'userToken';